import "./LoginPage.css";

const LoginPage = () => {
  return <></>;
};

export { LoginPage };
